<template>
  <CreateSubSequentComp></CreateSubSequentComp>
</template>
<script>
import CreateSubSequentComp from "../../components/Authorization/CreateSubSequent.vue";

export default {
  name: "Create SubSequent",
  components: { CreateSubSequentComp },
};
</script>
